/*
 * spurtcommerce
 * version 4.3
 * www.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import {
    Component, HostListener, Input, OnInit, ViewChild, PLATFORM_ID,
    Inject,
    Renderer2,
    OnDestroy, AfterViewInit
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { Router } from '@angular/router';
import { MatMenuTrigger } from '@angular/material/menu';
import { WishlistService } from '../../../../core/wishlist/wishlist.service';
import { AppSettings, Settings } from '../../../app.settings';
import { Title } from '@angular/platform-browser';
import { ConfigService } from '../../../../core/service/config.service';
import { environment } from '../../../../environments/environment';
import { OverlayReference } from '@angular/cdk/overlay/overlay-reference';
import {
    SwiperConfigInterface,
    SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewInit {
    // decorators
    private _overlayRef: OverlayReference;
    public start = 0;
    public end = 4;
    storename = '';

    @Input() categories: any;
    @Input() categoriesExpanded: any;
    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
    // param calls getProductList
    private brand: number;
    public co_categories = [];
    public col1_co_categories = [];
    public col2_co_categories = [];
    public col3_co_categories = [];


    // local storage
    public clearBrand: string;
    // selecting  category index
    public index: number;
    // category hover
    public hover: any;
    // category id  from event
    public categoryId: string;
    // make category active
    public categorylinkActive: string;
    // theme
    public settings: Settings;
    public Image: String = '';
    enteredButton = false;
    isMatMenuOpen = false;
    isMatMenu2Open = false;
    showButtons = false;

    public iframeHeight: number=0 ;


    public imagePath: string;
    prevButtonTrigger;
    public recheckIfInMenu: boolean;
    public activeSlug: any;
    public activeSubSlug: any;
    public config: SwiperConfigInterface = {};
    public maincat:any;

    private pagination: SwiperPaginationInterface = {
        el: '.swiper-pagination',
        clickable: true
    };
    constructor(
        public listSandbox: ListsSandbox,
        public appSettings: AppSettings, private ren: Renderer2,
        @Inject(PLATFORM_ID) private platformId: Object,
        private titleService: Title,
        public router: Router,
        private configService: ConfigService,
        ) {
        this.settings = this.appSettings.settings;
        if (isPlatformBrowser(this.platformId)) {
            const setTheme = localStorage.getItem('optionsTheme');
            this.settings.theme = setTheme;
        }
    }

    ngOnInit() {
        // console.log('this.categories', this.categories);
        this.storename = environment.storename;       
        this.imagePath = this.configService.getImageUrl();
        this.recheckIfInMenu = false;
        this.categoriesSplit();
    }
    // swipper for banners
    ngAfterViewInit() {

        // this.iframeHeight = window.innerHeight-50;

        this.iframeHeight = window.innerHeight/2;

        console.log("this.iframeHeight",this.iframeHeight)

        this.config = {
            slidesPerView: 4,
            pagination: false,
            autoplay: true,
            observer: true,
            navigation: true,
            grabCursor: true,
            lazy: {
                loadPrevNext: true
                // loadOnTransitionStart: true,
            },
            speed: 700,
            effect: 'slide'
        };
    }

    openMegaMenu() {
        const pane = document.getElementsByClassName('cdk-overlay-pane');
        [].forEach.call(pane, function (el) {
            if (el.children.length > 0) {
                if (el.children[0].classList.contains('mega-menu')) {
                    el.classList.add('mega-menu-pane');
                }
            }
        });
        const overlay = document.getElementsByClassName(' cdk-overlay-connected-position-bounding-box');
        [].forEach.call(overlay, function (el) {
            if (el.children[0].classList.contains('mega-menu-pane')) {
                el.classList.add('mega-overlay');
            }
        });

    }
    


    /** index for selecting categories.
     * @param index from event
     * @param categoryId from event
     * **/
    indexData(index, id, image, path) {
        this.Image = this.imagePath + '?path=' + path + '&name=' + image;

        if (this.categories && this.categories[index] && this.categories[index].children && this.categories[index].children.length > 0) {
            this.index = index;
            this.categoryId = id;
            this.trigger.openMenu();
            this.openMegaMenu();
        } else {
            // console.log('else index');
            this.trigger.closeMenu();
            return;
        }
    }
    // Make category link active if category got selected
    linkActive(mainCategory, slug) {
        console.log('selectred category', mainCategory);
        localStorage.setItem('specs', '');
        
        this.activeSubSlug = slug;
        this.activeSlug = mainCategory.categorySlug;
        this.categorylinkActive = this.categoryId;
        this.titleService.setTitle(mainCategory.name);
    }

    sublinkActive(subCategory, slug) {
        console.log('selectred category', subCategory);
        localStorage.setItem('specs', '');

        this.activeSubSlug = slug;
        this.activeSlug = subCategory.categorySlug;
        this.categorylinkActive = this.categoryId;
        this.titleService.setTitle(this.maincat);

    }


    /**
     * calls listSandbox productFilterData and send the value
     * @param productFilter set default value getting from template file
     */
    sendUniqueId(productFilter) {
        this.listSandbox.productFilterData.next(productFilter);
    }

    // getcategoryId value
    getCategory(id) {
        const params: any = {};
        params.categoryId = id;
        this.listSandbox.getCategory(params);
    }

    // getChildCategory value
    getChildCategory(id) {
        const params: any = {};
        params.categoryId = id;
        this.listSandbox.getCategory(params);
    }

    setTitle(title) {
        // console.log('selected title', title);
        this.titleService.setTitle(title);
    }
    setMainTitle(index, category) {
        localStorage.setItem('specs', '');

        this.activeSlug = category.categorySlug;


        if (this.categories && this.categories[index] && this.categories[index].children && this.categories[index].children.length > 0) {
            this.titleService.setTitle(category.name);
            this.index = index;
            this.categoryId = category.categoryId;
            this.trigger.openMenu();
        } else {
            // console.log('else main');
            this.trigger.closeMenu();
            return;
        }
    }

    over() {
        // console.log('cate',this.categories)
        console.log('this.recheckIfInMenu',this.recheckIfInMenu)
        setTimeout(() => {
            if (this.recheckIfInMenu === false) {
                this.trigger.closeMenu();
            }
        }, 175);
    }


    openResourceMenu(index, id) {

            this.col1_co_categories = [];
            this.col2_co_categories = [];
            this.col3_co_categories = [];
            this.co_categories =[];

        if (this.categories && this.categories[index] && this.categories[index].children && this.categories[index].children.length > 0) {

            
            this.index = index;
            this.categoryId = id;

            this.co_categories = this.categories[index].children;


            var row = Math.floor(this.co_categories.length / 3)
            var remaining_row = this.co_categories.length % 3

            let f1 = row+(remaining_row>=1?1:0)    
            this.col1_co_categories = this.co_categories.slice(0,f1);
            let f2 = f1+row+(remaining_row>1?1:0)    
            this.col2_co_categories = this.co_categories.slice(f1, f2);
            let f3 = f2+row    
            this.col3_co_categories = this.co_categories.slice(f2, f3);



            setTimeout(() => {
                if (this.recheckIfInMenu === true && this.co_categories.length>0) {
                    this.trigger.openMenu();
                    // this.openMegaMenu();
                }
            }, 300);
            // this.trigger.openMenu();
            // this.openMegaMenu();
            
        } else {
            this.trigger.closeMenu();
            // this.openMegaMenu();
            return;
        }
    }

    closeResourceMenu() {
        //   this.recheckIfInMenu = false;
        setTimeout(() => {
            if (this.recheckIfInMenu === false) {
                this.trigger.closeMenu();
            }
        }, 175);

    }


    ngOnDestroy() {
        this.activeSlug = '';
        //   this.activeSlug.activeSubSlug = '';
    }

    buttonEnter(trigger) {
        setTimeout(() => {
            // tslint:disable-next-line:triple-equals
            if (this.prevButtonTrigger && this.prevButtonTrigger != trigger) {
                this.prevButtonTrigger.closeMenu();
                this.prevButtonTrigger = trigger;
                trigger.openMenu();
                this.openMegaMenu();
            } else if (!this.isMatMenuOpen) {
                this.enteredButton = true;
                this.prevButtonTrigger = trigger;
                trigger.openMenu();
                this.openMegaMenu();
            } else {
                this.enteredButton = true;
                this.prevButtonTrigger = trigger;
            }
        });
    }

    buttonLeave(trigger, button) {
        setTimeout(() => {
            if (this.enteredButton && !this.isMatMenuOpen) {
                trigger.closeMenu();
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
            } if (!this.isMatMenuOpen) {
                trigger.closeMenu();
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
            } else {
                this.enteredButton = false;
            }
        }, 100);
    }

    menuenter() {
        this.isMatMenuOpen = true;
        if (this.isMatMenu2Open) {
            this.isMatMenu2Open = false;
        }
    }

    menuLeave(trigger, button) {
        setTimeout(() => {
            if (!this.isMatMenu2Open && !this.enteredButton) {
                this.isMatMenuOpen = false;
                trigger.closeMenu();
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
            } else {
                this.isMatMenuOpen = false;
            }
        }, 80);
    }

    // Mouse Over
    imageover(image, path) {
        console.log("Image",image)
        this.Image = '';
        if (image) {
         this.Image = this.imagePath + '?path=' + path + '&name=' + image;
              // console.log("Image @@@@@@",this.Image);   
     } 
     else {
        this.Image = "../../../../assets/images/default_image.png"
     }
   
 }

 mainimageover(image, path) {

    this.Image = '';

}

public handleMissingImage(event: Event) {
    (event.target as HTMLImageElement).style.display = 'none';
  }

  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = '';  // Set the image source to empty to hide it
    imgElement.style.display = 'none';  // Optionally, hide the image
}



//   imageover(image, path) {
//     this.Image = '';
//     const imageUrl = this.imagePath + '?path=' + path + '&name=' + image;

//     this.checkIfImageExists(imageUrl, (exists) => {
//         if (exists) {
//             this.Image = imageUrl;
//          // console.log('Image exists');  
//         } else {
//             this.Image = '';
//           //console.log('Image does not exist');  
//         }
//       });
//   }


//   checkIfImageExists(url, callback) {
//         const img = new Image();
//         img.src = url;

//         img.onload = () => {
//             callback(true);
//         };

//         img.onerror = () => {
//             callback(false);
//         };
//  }





categoriesSplit() {
        // console.log('--categories',this.categories)
}

Increase() {
    this.trigger.openMenu();
    this.openMegaMenu();

    if (this.end >= this.categories[this.index].children.length)
        return
    this.recheckIfInMenu = true;
    this.start += 4;
    this.end += 4;
    this.co_categories = this.categories[this.index].children.slice(this.start, this.end);
}

decrease() {
    this.trigger.openMenu();
    this.openMegaMenu();
    this.recheckIfInMenu = true;
    if (this.start == 0)
        return;
    this.start -= 4;
    this.end -= 4;
    this.co_categories = this.categories[this.index].children.slice(this.start, this.end);
}

impotlocal(){
    localStorage.setItem("specialdeal","0")
}

}

